export const MUTATE_SHIFTS_URL = 'MUTATE_SHIFTS_URL';
